import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RisksCommaSeparatedPipe } from './risks-comma-separated.pipe';

@NgModule({
  declarations: [RisksCommaSeparatedPipe],
  imports: [CommonModule],
  exports: [RisksCommaSeparatedPipe],
})
export class RiskModule {}
